import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import { Track } from '@platzi/commons';
import { Button } from '@platzi/ui';
import { socialNetwork } from './socialNetwork';
import { ShareModal } from './ShareModal';
import styles from './ShareButton.module.sass';
import classnames from 'classnames';

let clickEventSent = false;

export const ShareButton = (props) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [pathToShare, setPathToShare] = useState('');

  useEffect(() => {
    setPathToShare(window.location.href);
  }, []);

  const handleClick = () => {
    if (props.recordClickEvent && !clickEventSent) {
      Track.send({
        ...props.recordClickEvent,
      });
      clickEventSent = true;
    }
    setShowShareModal(true);
  };

  return (
    <>
      <Button
        as="button"
        color="sky"
        hierarchy="tertiary"
        customClass={classnames(styles.Button, props.customClass)}
        onClick={handleClick}
      >
        <FontAwesomeIcon icon={faShareNodes} />
        {props.isLogged ? props.messages?.isLogged : props.messages?.notLogged}
      </Button>

      <ShareModal
        socialNetwork={socialNetwork(pathToShare, props.socialNetworkTitle)}
        showModal={showShareModal}
        handleShowModal={setShowShareModal}
        pathToShare={pathToShare}
        sharedCopy={props.messages?.sharedCopy}
        recordSocialMediaClick={props.recordSocialMediaClick}
      />
    </>
  );
};
